import { Box, Stack, Tooltip } from '@mui/material';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { FractionDigitsFormattedNumber, PoolTypography } from '@synergy/components-next';
import { PoolMath } from '@synergy/utils';
import { ReactElement } from 'react';

import { useArticleCardContext } from '../article-card';

export const ArticleCardContentPriceInfo = (): ReactElement => {
    const { article } = useArticleCardContext();
    const { mainPrice, currentSpecialPrice, currentSpecialPriceUntil, currency, priceQuantity } = article;

    const percent =
        mainPrice !== 0 && !!currentSpecialPrice && PoolMath.getPercentDifference(mainPrice, currentSpecialPrice);

    return (
        <Tooltip
            placement="top-start"
            title={
                currentSpecialPriceUntil ? (
                    <FormattedMessage
                        id="app.specialOffer.tooltip"
                        values={{ date: <FormattedDate value={currentSpecialPriceUntil} /> }}
                    />
                ) : (
                    ''
                )
            }
        >
            <Stack sx={{ mt: 0.5 }}>
                <PoolTypography
                    variant="h5"
                    color={currentSpecialPrice ? 'error.dark' : 'common.black'}
                    component="div"
                >
                    <FractionDigitsFormattedNumber
                        value={(currentSpecialPrice || mainPrice) * priceQuantity}
                        currency={currency}
                    />
                </PoolTypography>
                {!!currentSpecialPrice && percent && (
                    <Box typography="body1">
                        <Box sx={{ textDecoration: 'line-through' }} component="span">
                            <FractionDigitsFormattedNumber value={mainPrice * priceQuantity} currency={currency} />
                        </Box>{' '}
                        <Box color="error.dark" component="span">
                            <FormattedNumber value={-percent} style="percent" />
                        </Box>
                    </Box>
                )}
            </Stack>
        </Tooltip>
    );
};
